import React, { useState } from "react";
import {
  Layout, Row, Col
} from "antd";
import "antd/dist/reset.css";
import "./customLayout.css";
import {
  TeamOutlined,
  QuestionOutlined,
  InfoCircleOutlined,
  FilePptOutlined,
} from "@ant-design/icons";
import { useCookies } from "react-cookie";

import { NavLink, useNavigate } from "react-router-dom";
import {
  logout,
  getProfile,
  isAuthorizedRole,
  RenderAnonymous,
  RenderAuthenticated,
} from "@seims/shared/src/security";
import { CookieConsentView } from "../components/CookieConsentView";
import { AnonymousLayout } from "./AnonymousLayout";
import AuthorizedLayout from "./AuthorizedLayout";

const { Header, Content, Footer, Sider } = Layout;

export const CustomLayout = () => {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [collapsed, setCollapsed] = useState(false);
  const [userData, setUserData] = useState(getProfile());
  const [visible, setVisible] = useState(false);
  const [userVisible, setUserVisible] = useState(false);
  const [hasUpdated, setHasUpdated] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [cookies] = useCookies(["cookieConsent"]);


  const [steps, setSteps] = useState([
    {
      target: ".content-container",
      title: `New on this website ? `,
      content: "This section gives an overview of the NYS programme.",
      disableBeacon: true,
    },
    {
      target: ".profile",
      title: `Profile `,
      content:
        "Profile button allows you to perform the following: Update password, Manage profile & Logout.",
    },
    {
      target: ".side-menu",
      title: `Application `,
      content: "This link allows you to apply for the NYS programme.",
    },
  ]);

  const [run, setRun] = useState(false);
  const [tour, setTour] = useState();

  const handleClick = (e) => {
    e.preventDefault();

    setRun(true);
  };
  const navigate = useNavigate();

  let path = `/nys/candidate/registration`;
  let path1 = "/nys/programme/registration";

  const handleAccept = (accepted) => {
    if (accepted === false) {
      setAccepted(false);
      setVisible(false);
      setUserVisible(false);
    } else {
      setVisible(false);
      navigate(path);
      localStorage.setItem("nysTerms", accepted);
      // setUserVisible(true);
      setAccepted(true);
    }
  };
  const handleCancel = () => {
    setUserVisible(false);
  };

  const username = userData.firstName;
  const Logout = () => {
    logout();
  };
  const cancel = () => {};
  const onCollapse = (collapse) => {
    setCollapsed(collapse);
  };

  const handleMenuClick = (e) => {};

  

  const getMenuItems = () => {
    return [
      isAuthorizedRole(["ADMIN", "CORE", "NYS_CANDIDATE"]) &&
        getItem(
          <NavLink to="/nys/candidate/create"> Application </NavLink>,
          "Application",
          <TeamOutlined
            style={{
              fontSize: "25px",
              color: "#FFF",
              marginLeft: "0px",
            }}
          />,
          null,
          ""
        ),
      isAuthorizedRole(["NYS_CANDIDATE"]) &&
        getItem(
          <NavLink to="/nys/about-us"> About Us </NavLink>,
          "About",
          <InfoCircleOutlined
            style={{
              fontSize: "25px",
              color: "#FFF",
              marginLeft: "0px",
            }}
          />,
          null,
          ""
        ),
      isAuthorizedRole(["NYS_CANDIDATE"]) &&
        getItem(
          <NavLink to="/nys/privacy-statement"> Privacy Statement </NavLink>,
          "Privacy",
          <FilePptOutlined
            style={{
              fontSize: "25px",
              color: "#FFF",
              marginLeft: "0px",
            }}
          />,
          null,
          ""
        ),
      isAuthorizedRole(["NYS_CANDIDATE"]) &&
        getItem(
          <NavLink to="/nys/frequently-asked-questions"> FAQ </NavLink>,
          "Faq",
          <QuestionOutlined
            style={{
              fontSize: "25px",
              color: "#FFF",
              marginLeft: "0px",
            }}
          />,
          null,
          ""
        ),
    ];
  };

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const menuItems = getMenuItems();

  

  return (
    <div>
      {/* <Tour run={true} tour={tour} />
      <Tour run={run} tour={steps} /> */}

      <RenderAuthenticated>
        <AuthorizedLayout />
      </RenderAuthenticated>

      <RenderAnonymous>
        <AnonymousLayout />
      </RenderAnonymous>


      <Row justify={"center"}>
        <Col sm={22} md={10}>
          {!cookies.cookieConsent && <CookieConsentView />}
        </Col>
      </Row>
    </div>
  );
};

export default CustomLayout;
